import { render } from "./WhatWeValue.vue?vue&type=template&id=343afdf2&scoped=true&ts=true"
import script from "./WhatWeValue.vue?vue&type=script&lang=ts"
export * from "./WhatWeValue.vue?vue&type=script&lang=ts"

import "./WhatWeValue.vue?vue&type=style&index=0&id=343afdf2&scoped=true&lang=scss"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343afdf2"]])

export default __exports__